<template>
  <v-card height="100%" tile>
    <v-card-text>
      <v-toolbar flat>
        <v-toolbar-title class="col-2">{{
          resx.labels.searchContractor
        }}</v-toolbar-title>
        <search-contractor-filters
          class="col-8"
          v-model="filters"
        ></search-contractor-filters>
        <v-btn v-on:click="viewVisits()" class="col-2">{{
          resx.labels.viewVisits
        }}</v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </v-card-text>
    <v-card-text>
      <v-row fill-height>
        <v-col fill-height class="scrollable">
          <v-card-text>
            <search-contractor-results
              :filter="filters.text"
            ></search-contractor-results>
          </v-card-text>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
"use strict";

import searchContractorFilters from "./search-contractor-filters.view.vue";
import searchContractorResults from "./search-contractor-results.view.vue";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

export default {
  name: "searchContractor",
  components: { searchContractorFilters, searchContractorResults },
  data() {
    return {
      filters: this.$store.state.search.contractor.filters
    };
  },
  methods: {
    viewVisits() {
      this.filters = null;
      this.$router.push("/view/visits");
    }
  }
};
</script>
<style lang="scss">
#searchContractorResult {
  .v-list-item__action {
    align-self: center;
    margin-top: 16px;
    margin-bottom: 0px;
  }

  .v-list-item__action {
    position: initial;
  }

  .v-card__title .v-card__title {
    word-break: break-word;
  }

  .v-card {
    overflow-y: auto;
  }
}

.v-card__text .v-toolbar .v-input {
  padding-top: 26px;
}

.v-toolbar__title {
  font-weight: 500;
}

.search-contractor-filters {
  padding-top: 26;
}
</style>
